
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telemetry",
      function () {
        return require("private-next-pages/telemetry.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telemetry"])
      });
    }
  